import { createApp } from 'vue'
import router from './router'
import { DMUIComponents, ErrorLogger } from 'dmui_components'
import { setupDmui } from 'datamaran_ui'
import App from './App.vue'
import 'datamaran_ui/style.css'
import { createPinia } from 'pinia'

// Initialize the error logger, First argument is application name
new ErrorLogger('submaran')
// create the app
const app = createApp(App)
const pinia = createPinia()	
app.use(pinia)
app.use(router)
app.use(DMUIComponents)
app.use(setupDmui)
app.mount('#app')
